import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  getSavedSearches,
  getFilterData,
  savedSearch,
  SearchesDelete,
} from '../../helpers/saved_searches_helper';
// Crypto Redux States
import { SavedSearchTypes } from './actionTypes';
import {
  getSavedSearchesSuccess,
  getSavedSearchesFail,
  getFilterDataSuccess,
  getFilterDataFail,
  saveSearchSuccess,
  saveSearchFail,
  deleteSearchesSuccess,
  deleteSearchesFail,
} from './actions';

function* fetchSavedSearchesList(data: any): any {
  try {
    const response: Promise<any> = yield call(getSavedSearches, data.payload);
    yield put(getSavedSearchesSuccess(response));
  } catch (error) {
    yield put(getSavedSearchesFail(error));
  }
}

function* fetchFilterData(data: any) {
  try {
    const response: Promise<any> = yield call(getFilterData, data.payload);
    yield put(getFilterDataSuccess(response));
  } catch (error) {
    yield put(getFilterDataFail(error));
  }
}

function* saveSearchData(data: any) {
  // console.log("saveSearchDatasaveSearchDatasaveSearchDatasaveSearchDatasaveSearchData");

  try {
    const response: Promise<any> = yield call(savedSearch, data.payload);

    /* const response2: Promise<any> = yield call(fetchSavedSearchesList, {
      payload: data
    }); */

    yield put(saveSearchSuccess(response));
  } catch (error) {
    yield put(saveSearchFail(error));
  }
}
function* DeleteSearchData(data: any) {
  try {
    const response: Promise<any> = yield call(SearchesDelete, data.payload);

    /* const response2: Promise<any> = yield call(fetchSavedSearchesList, {
      payload: data
    }); */

    yield put(deleteSearchesSuccess(response));
  } catch (error) {
    yield put(deleteSearchesFail(error));
  }
}

function* SavedSearchesSaga() {
  yield takeEvery(SavedSearchTypes.GET_SAVED_SEARCHES, fetchSavedSearchesList);
  yield takeEvery(SavedSearchTypes.GET_FILTER_DATA, fetchFilterData);
  yield takeEvery(SavedSearchTypes.SAVE_SEARCH, saveSearchData);
  yield takeEvery(SavedSearchTypes.DELETE_SEARCHES, DeleteSearchData);

  //yield takeLatest(SavedSearchTypes.SAVE_SEARCH, saveSearchData);
}

export default SavedSearchesSaga;
